import {
  ModalSubFeedbackContentPositiveComments,
  ModalSubFeedbackContentPositiveReasons,
  ModalSubFeedbackContentPositiveSummary,
  type PositiveData,
  type PositiveStep,
  type Step,
} from "~components/ModalSubFeedback";

type ModalSubFeedbackContentPositiveProps = {
  onDismiss: () => void;
  positiveData: PositiveData;
  setPositiveData: (positiveData: PositiveData) => void;
  setStep: (step: Step) => void;
  subName?: string;
  onSubmit: (data: PositiveData) => void;
  hasSubmissionError?: boolean;
  positiveStep: PositiveStep;
  setPositiveStep: (positiveStep: PositiveStep) => void;
};

export function ModalSubFeedbackContentPositive(props: ModalSubFeedbackContentPositiveProps) {
  const {
    onDismiss,
    positiveData,
    setPositiveData,
    setStep,
    subName,
    onSubmit,
    hasSubmissionError,
    positiveStep,
    setPositiveStep,
  } = props;

  return (
    <>
      {positiveStep === "reasons" && (
        <ModalSubFeedbackContentPositiveReasons
          goBackToRatingStep={() => setStep("rating")}
          onDismiss={onDismiss}
          positiveData={positiveData}
          setPositiveData={setPositiveData}
          setPositiveStep={setPositiveStep}
        />
      )}
      {positiveStep === "comments" && (
        <ModalSubFeedbackContentPositiveComments
          onDismiss={onDismiss}
          positiveData={positiveData}
          setPositiveData={setPositiveData}
          setPositiveStep={setPositiveStep}
          subName={subName}
          onSubmit={onSubmit}
          hasSubmissionError={hasSubmissionError}
        />
      )}
      {positiveStep === "summary" && (
        <ModalSubFeedbackContentPositiveSummary onDismiss={onDismiss} />
      )}
    </>
  );
}
